import styles from './DefendantBackHalf.module.css';

export const DefendantBackHalf = () => {

  return (
    <div
      className={`${styles.cell} ${styles['page2-outer-horizontal-grid']}`}
    >
      <div
        className={styles['page2-back-half']}
      >
        <div
          className={styles['page2-halves']}
        >
          <div
            className={styles['centered-flex']}
          >
            <h3
              className={`${styles['center-align']} ${styles['print-h3']}`}
            >
              <span
                className={`${styles['bold-underline']} ${styles['print-span']} ${styles['large-text']}`}
              >
                KEEP THIS COPY FOR REFERENCE
              </span>
            </h3>
          </div>
          <p className={styles['print-p']}>
            &nbsp;You are charged with a <span className={`${styles.underline} ${styles['print-span']}`}>civil violation</span> within the<br />
            jurisdiction of the Judicial Bureau of Vermont. The Judicial<br />
            Bureau is designed to allow you to speak for yourself without<br />
            an attorney, but you may hire an attorney at your own<br />
            expense. The Judicial Bureau will not provide an attorney to<br />
            you, and its staff will not provide legal advice to you.<br />
            <br />
            &nbsp;If you <span className={`${styles.underline} ${styles['print-span']}`}>accept the penalties</span> for the alleged violation, then<br />
            you may waive your right to appear in court and pay the<br />
            waiver amount.<br />
            <br />
            &nbsp;If you <span className={`${styles.underline} ${styles['print-span']}`}>request a hearing</span>, at least one hearing will be<br />
            scheduled. The hearing will most likely be remote via video<br />
            conference. A <span className={`${styles.underline} ${styles['print-span']}`}>corporation</span> must have an attorney or corporate<br />
            officer (i.e., president, vice-president) appear in court. A<br />
            <span className={`${styles.underline} ${styles['print-span']}`}>minor</span> must be accompanied by a parent or legal guardian.<br />
            <br />
            &nbsp;The law enforcement officer who issued the complaint is<br />
            the prosecutor. The judge will not discuss the case with you<br />
            or the officer except during the hearing. <span className={`${styles.underline} ${styles['print-span']}`}>The judge does not<br />
              have authority to issue a &quot;warning&quot; or a different violation,</span><br />
            even when leniency is appropriate.  The decision to issue a<br />
            warning rather than file a complaint, or issue a different<br />
            violation, rests with the law enforcement officer.<br />
            <br />
            &nbsp;The hearing is a summary <span className={`${styles.underline} ${styles['print-span']}`}>trial</span> without a jury. The<br />
            <span className={`${styles.underline} ${styles['print-span']}`}>burden of proof</span> is on the State or Municipality to prove the<br />
            violation by clear and convincing evidence, which means that<br />
            the State or Municipality has to prove that the facts asserted<br />
            on the violation are <span className={`${styles.underline} ${styles['print-span']}`}>highly probable</span>. You and the<br />
            State/Municipality may offer testimony and exhibits into<br />
            evidence. All witnesses must appear at the hearing and<br />
            testify truthfully under oath. Written statements usually are<br />
            not allowed in evidence.
          </p>
        </div>

        <div className={styles['page2-halves']}>
          <br />
          <p className={styles['print-p']}>
            &nbsp;If the State or Municipality satisfies the burden of proof,<br />
            then judgment will be entered against you. Depending on the<br />
            type of violation, you may be subjected to a variety of<br />
            penalties as set by law (e.g., fine, surcharge, court costs,<br />
            points, driving suspension, hunting/fishing/trapping license<br />
            suspension and Fish &amp; Wildlife restitution). If the State or<br />
            Municipality fails to meet the burden of proof, judgment will<br />
            be entered in your favor.<br />
            <br />
            &nbsp;Most decisions are delivered orally in court at the end of<br />
            the hearing, but some decisions are issued in writing and<br />
            mailed to the parties. Occasionally, more than one hearing is<br />
            required for the judge to reach a decision.<br />
            <br />
            &nbsp;Either party may appeal the decision to the Superior<br />
            Court. The filing fee to appeal is $120.00. The appeal will be<br />
            on the record (meaning neither party will be allowed to<br />
            present new evidence), unless you file a written request for a<br />
            new trial by judge or a new trial by jury.
          </p>
          <div className={styles['centered-flex']}>
            <h3 className={`${styles['center-align']} ${styles.underline} ${styles['print-h3']}`}><span className={styles['print-span']}>CONTACT THE JUDICIAL BUREAU</span></h3>
          </div >
          <p className={styles['print-p']}>
            &nbsp;The Judicial Bureau is open Monday through Friday, <br />
            except holidays, between 8:00 a.m. and 4:30 p.m. The<br />
            Judicial Bureau intends to digitally scan all written<br />
            correspondence. Thus, letters and motions should be <span className={`${styles.underline} ${styles['print-span']}`}>typed<br />
              on white letter-sized paper</span> (8<span className={styles.rotate}>&frac12;</span> in. by 11 in.) and signed in<br />
            black or dark blue ink.<br />
          </p>
          <div className={styles['centered-flex']}>
            <span className={`${styles['print-span']} ${styles.bold}`}>JUDICIAL BUREAU</span>
            <span className={`${styles['print-span']} ${styles.bold}`}>82 Railroad Row, POB 607</span>
            <span className={`${styles['print-span']} ${styles.bold}`}>White River Jct., VT 05001</span>
            <span className={`${styles['print-span']} ${styles.bold}`}>(802) 295-8869</span>
            <span className={`${styles['print-span']} ${styles.bold}`}>VJB@vtcourts.gov</span>
            <span className={`${styles['print-span']} ${styles.bold}`}>Visit our website www.vermontjudiciary.org</span>
          </div >
        </div >

      </div >
    </div >

  )
}
